<template>
  <div class="tabbar">
    <div
      v-for="tab in tabs"
      :key="tab.path"
      class="tabbar_item"
      :class="{ active: isActive(tab.path) }"
      @click="go(tab.path)"
    >
      <div class="tabbar_icon">
        <!-- 首页：房子图标 -->
        <svg v-if="tab.key === 'home'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <polyline points="9 22 9 12 15 12 15 22" />
        </svg>
        <!-- 订单：列表图标 -->
        <svg v-else-if="tab.key === 'order'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="8" y1="13" x2="16" y2="13" />
          <line x1="8" y1="17" x2="16" y2="17" />
          <line x1="8" y1="9" x2="10" y2="9" />
        </svg>
        <!-- 我的：人像图标 -->
        <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      </div>
      <div class="tabbar_text">{{ tab.label }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdultNewTabBar',
  data() {
    return {
      tabs: [
        { key: 'home',  path: '/new-page-money-list',  label: '首页' },
        { key: 'order', path: '/new-page-order-list',  label: '订单' },
        { key: 'my',    path: '/new-page-my',          label: '我的' },
      ]
    }
  },
  methods: {
    isActive(path) {
      return this.$route.path === path
    },
    go(path) {
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
    }
  }
}
</script>

<style scoped>
.tabbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 58px;
  background: #ffffff;
  border-top: 1px solid #eee;
  display: flex;
  z-index: 98;          /* 低于页面内的固定支付栏(z-index 99) */
  padding-bottom: env(safe-area-inset-bottom); /* iPhone X+ 安全区 */
}
.tabbar_item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
  cursor: pointer;
  transition: color 0.2s;
  user-select: none;
}
.tabbar_item.active {
  color: #1565c0;       /* 选中态：深蓝 */
}
.tabbar_icon {
  width: 26px;
  height: 26px;
  margin-bottom: 2px;
}
.tabbar_icon svg {
  width: 100%;
  height: 100%;
}
.tabbar_text {
  font-size: 11px;
  line-height: 1;
}
</style>